(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-announcement-rotator')) {
    customElements.define('vt-announcement-rotator', class extends HTMLElement {
      connectedCallback() {
        this.msgs = [...this.querySelectorAll('.vt-announcement__msg')];
        this.i = 0;
        const btn = this.parentElement.querySelector('.vt-announcement__next');
        if (btn) btn.addEventListener('click', () => this.go(this.i + 1));
        if (this.msgs.length > 1) this.timer = setInterval(() => this.go(this.i + 1), (Number(this.dataset.speed) || 5) * 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      go(n) { this.msgs[this.i].hidden = true; this.i = (n + this.msgs.length) % this.msgs.length; this.msgs[this.i].hidden = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mq = window.matchMedia('(min-width: 750px)');
    const sync = () => document.querySelectorAll('.vt-footer__acc').forEach((d) => { d.open = mq.matches ? true : d.open && d.dataset.touched === '1'; });
    document.addEventListener('toggle', (e) => { if (e.target.classList && e.target.classList.contains('vt-footer__acc')) e.target.dataset.touched = '1'; }, true);
    mq.addEventListener('change', sync);
    if (!mq.matches) document.querySelectorAll('.vt-footer__acc').forEach((d) => { d.open = false; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-main-collection"]) return;
  try {
    
  if (!customElements.get('vt-main-collection')) {
    customElements.define('vt-main-collection', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-vt-filter-form]');
        this.drawer = this.querySelector('[data-vt-drawer]');
        this.overlay = this.querySelector('.vt-main-collection__overlay');
        this.opener = this.querySelector('[data-vt-open]');
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        if (this.form) {
          this.form.addEventListener('change', this.onChange);
          this.form.addEventListener('submit', this.onSubmit);
        }
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        document.documentElement.style.removeProperty('overflow');
      }
      onClick = (event) => {
        if (event.target.closest('[data-vt-open]')) this.toggle(true);
        else if (event.target.closest('[data-vt-close]')) this.toggle(false);
      };
      onKey = (event) => {
        if (event.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) this.toggle(false);
      };
      toggle(open) {
        if (!this.drawer) return;
        this.drawer.classList.toggle('is-open', open);
        if (this.overlay) this.overlay.hidden = !open;
        if (this.opener) this.opener.setAttribute('aria-expanded', String(open));
        if (open) {
          document.documentElement.style.overflow = 'hidden';
          const first = this.drawer.querySelector('button, select, input, a');
          if (first) first.focus();
        } else {
          document.documentElement.style.removeProperty('overflow');
          if (this.opener) this.opener.focus();
        }
      }
      onChange = () => {
        if (this.form.requestSubmit) this.form.requestSubmit();
        else { this.onSubmit(); this.form.submit(); }
      };
      onSubmit = () => {
        this.form.querySelectorAll('input[type="number"]').forEach((input) => {
          if (input.value === '') input.disabled = true;
        });
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-media-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-snap-carousel')) {
    class VtSnapCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.dots = this.querySelector('[data-dots]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index() - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.index() + 1));
        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.track);
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
      items() { return Array.from(this.track.children); }
      step() {
        const it = this.items();
        if (it.length > 1) return it[1].offsetLeft - it[0].offsetLeft;
        return this.track.clientWidth || 1;
      }
      count() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 2) return 1;
        return Math.min(this.items().length, Math.ceil(max / this.step() - 0.05) + 1);
      }
      index() { return Math.min(this.count() - 1, Math.round(this.track.scrollLeft / this.step())); }
      go(i) {
        const n = this.count();
        const target = Math.max(0, Math.min(n - 1, i));
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({ left: target === n - 1 ? max : target * this.step(), behavior: 'smooth' });
      }
      build() {
        const n = this.count();
        if (this.dots) {
          if (this.dots.childElementCount !== n) {
            this.dots.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.setAttribute('aria-label', (i + 1) + ' / ' + n);
              b.addEventListener('click', () => this.go(i));
              this.dots.appendChild(b);
            }
          }
          this.dots.hidden = n < 2;
        }
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const n = this.count();
        const i = this.track.scrollLeft >= max - 2 ? n - 1 : this.index();
        if (this.dots) Array.from(this.dots.children).forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }
    customElements.define('vt-snap-carousel', VtSnapCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-product-carousel')) {
    customElements.define('vt-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vt-track]');
        this.addEventListener('click', this.onClick);
        if (this.track) this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.dataset.url) this.loadRecommendations();
        this.onScroll();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
      async loadRecommendations() {
        try {
          const res = await fetch(this.dataset.url);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('vt-product-carousel [data-vt-track]');
          if (fresh && fresh.children.length) {
            this.track.innerHTML = fresh.innerHTML;
            this.track.scrollLeft = 0;
            this.onScroll();
          } else if (!this.track.children.length) {
            this.setAttribute('data-empty', '');
          }
        } catch (e) {
          if (!this.track.children.length) this.setAttribute('data-empty', '');
        }
      }
      onClick = (event) => {
        const btn = event.target.closest('[data-vt-dir]');
        if (!btn || !this.track) return;
        const dir = Number(btn.dataset.vtDir);
        this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
      };
      onScroll = () => {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.querySelectorAll('[data-vt-dir]').forEach((btn) => {
          const dir = Number(btn.dataset.vtDir);
          btn.disabled = max <= 0 ? true : dir < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
        });
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-ranking-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-ranking-tabs')) {
    class VtRankingTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            let next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            if (next !== null) { e.preventDefault(); this.select(next); this.tabs[next].focus(); }
          });
          tab.addEventListener('shopify:block:select', () => this.select(i));
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    }
    customElements.define('vt-ranking-tabs', VtRankingTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-snap-carousel')) {
    class VtSnapCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.dots = this.querySelector('[data-dots]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index() - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.index() + 1));
        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.track);
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
      items() { return Array.from(this.track.children); }
      step() {
        const it = this.items();
        if (it.length > 1) return it[1].offsetLeft - it[0].offsetLeft;
        return this.track.clientWidth || 1;
      }
      count() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 2) return 1;
        return Math.min(this.items().length, Math.ceil(max / this.step() - 0.05) + 1);
      }
      index() { return Math.min(this.count() - 1, Math.round(this.track.scrollLeft / this.step())); }
      go(i) {
        const n = this.count();
        const target = Math.max(0, Math.min(n - 1, i));
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({ left: target === n - 1 ? max : target * this.step(), behavior: 'smooth' });
      }
      build() {
        const n = this.count();
        if (this.dots) {
          if (this.dots.childElementCount !== n) {
            this.dots.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.setAttribute('aria-label', (i + 1) + ' / ' + n);
              b.addEventListener('click', () => this.go(i));
              this.dots.appendChild(b);
            }
          }
          this.dots.hidden = n < 2;
        }
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const n = this.count();
        const i = this.track.scrollLeft >= max - 2 ? n - 1 : this.index();
        if (this.dots) Array.from(this.dots.children).forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }
    customElements.define('vt-snap-carousel', VtSnapCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-shop-videos')) {
    class VtShopVideos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.items = Array.from(this.track.querySelectorAll('[data-item]'));
        if (!this.items.length) return;
        this.dots = this.querySelector('[data-dots]');
        this.active = -1;
        this.visible = false;
        this.userPaused = new Set();
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.items.forEach((item, i) => {
          const video = item.querySelector('video');
          const media = item.querySelector('.vt-shopvid__media');
          if (video) {
            video.addEventListener('play', () => { item.dataset.playing = ''; });
            video.addEventListener('pause', () => { delete item.dataset.playing; });
          }
          if (media) {
            media.addEventListener('click', (e) => {
              e.preventDefault();
              if (i !== this.active) { this.go(i); return; }
              this.toggle(i);
            });
          }
        });

        if (this.dots) {
          this.dots.innerHTML = '';
          this.items.forEach((_, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', (i + 1) + ' / ' + this.items.length);
            b.addEventListener('click', () => this.go(i));
            this.dots.appendChild(b);
          });
          this.dots.hidden = this.items.length < 2;
        }

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.playback();
        }, { threshold: 0.35 });
        this.io.observe(this);

        const start = Math.floor((this.items.length - 1) / 2);
        requestAnimationFrame(() => {
          this.track.scrollLeft = this.offsetFor(start);
          this.sync();
        });
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
      offsetFor(i) {
        const it = this.items[i];
        return it.offsetLeft + it.offsetWidth / 2 - this.track.clientWidth / 2;
      }
      go(i) {
        const k = Math.max(0, Math.min(this.items.length - 1, i));
        this.track.scrollTo({ left: this.offsetFor(k), behavior: 'smooth' });
      }
      sync() {
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let best = 0;
        let dist = Infinity;
        this.items.forEach((it, i) => {
          const d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - center);
          if (d < dist) { dist = d; best = i; }
        });
        if (best === this.active) return;
        this.active = best;
        this.items.forEach((it, i) => {
          if (i === best) it.dataset.active = ''; else delete it.dataset.active;
        });
        if (this.dots) Array.from(this.dots.children).forEach((d, k) => d.setAttribute('aria-current', k === best ? 'true' : 'false'));
        this.playback();
      }
      playback() {
        this.items.forEach((it, i) => {
          const v = it.querySelector('video');
          if (!v) return;
          const shouldPlay = this.visible && i === this.active && !this.userPaused.has(i) && !this.reduced;
          if (shouldPlay) {
            v.muted = true;
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }
      toggle(i) {
        const v = this.items[i].querySelector('video');
        if (!v) return;
        if (v.paused) {
          this.userPaused.delete(i);
          this.reduced = false;
          v.muted = true;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          this.userPaused.add(i);
          v.pause();
        }
      }
    }
    customElements.define('vt-shop-videos', VtShopVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-size-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-size-finder')) {
    class VtSizeFinder extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-open]');
        this.form = this.querySelector('[data-form]');
        this.result = this.querySelector('[data-result]');
        this.error = this.querySelector('[data-error]');
        if (!this.dialog || !this.opener || !this.form) return;
        try {
          this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        } catch (e) {
          this.config = { rows: [] };
        }
        this.opener.addEventListener('click', () => this.open());
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => this.opener.focus());
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.calculate(); });
        const again = this.querySelector('[data-again]');
        if (again) again.addEventListener('click', () => this.reset());
      }
      open() {
        this.reset();
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        const first = this.form.querySelector('input');
        if (first) first.focus();
      }
      reset() {
        this.form.hidden = false;
        this.result.hidden = true;
        this.error.hidden = true;
      }
      calculate() {
        const top = parseFloat(this.form.elements.top.value);
        const under = parseFloat(this.form.elements.under.value);
        const valid = isFinite(top) && isFinite(under) && under >= 50 && under <= 150 && top > under && top - under < 40;
        if (!valid) {
          this.error.hidden = false;
          (isFinite(top) ? this.form.elements.under : this.form.elements.top).focus();
          return;
        }
        this.error.hidden = true;
        const cups = [['A', 10], ['B', 12.5], ['C', 15], ['D', 17.5], ['E', 20], ['F', 22.5], ['G', 25], ['H', 27.5]];
        const diff = top - under;
        let cup = cups[0];
        cups.forEach((c) => { if (Math.abs(c[1] - diff) < Math.abs(cup[1] - diff)) cup = c; });
        const band = Math.round(under / 5) * 5;
        const rows = Array.isArray(this.config.rows) ? this.config.rows : [];
        const row = rows.find((r) => under >= Number(r.min) && under < Number(r.max)) || rows.find((r) => under === Number(r.max));

        const sizeEl = this.querySelector('[data-size]');
        const detailEl = this.querySelector('[data-detail]');
        const hintEl = this.querySelector('[data-hint]');
        const detail = String(this.config.detail || '')
          .split('[band]').join(band)
          .split('[cup]').join(cup[0]);
        sizeEl.textContent = row && row.size ? row.size : cup[0] + band;
        detailEl.textContent = row ? detail : (this.config.noMatch || detail);
        hintEl.textContent = row && row.hint ? row.hint : '';
        hintEl.hidden = !(row && row.hint);

        this.form.hidden = true;
        this.result.hidden = false;
        const guide = this.result.querySelector('a, button');
        if (guide) guide.focus();
      }
    }
    customElements.define('vt-size-finder', VtSizeFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-slideshow-peek"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-slideshow-peek')) {
    class VtSlideshowPeek extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.count = Number(this.dataset.count) || 0;
        this.offset = Number(this.dataset.offset) || 0;
        this.pos = this.offset;
        this.delay = (Number(this.dataset.speed) || 5) * 1000;
        this.auto = this.dataset.autoplay === 'true' && this.count > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.count < 2) return;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i + this.offset)));
        this.track.addEventListener('transitionend', (e) => { if (e.target === this.track) this.normalize(); });
        this.track.addEventListener('click', (e) => this.onClick(e), true);
        const vp = this.querySelector('.vt-slideshow-peek__viewport');
        vp.addEventListener('pointerdown', (e) => this.onDown(e));
        vp.addEventListener('pointermove', (e) => this.onMove(e));
        vp.addEventListener('pointerup', (e) => this.onUp(e));
        vp.addEventListener('pointercancel', (e) => this.onUp(e));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) this.go(i);
          this.stop();
          this.paused = true;
        });
        this.addEventListener('shopify:block:deselect', () => { this.paused = false; this.start(); });
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      setPos(pos, animate) {
        this.pos = pos;
        this.classList.toggle('is-jumping', !animate);
        this.style.setProperty('--vt-sp-pos', pos);
        if (!animate) { void this.track.offsetWidth; this.classList.remove('is-jumping'); }
        this.update();
      }
      real() { return (((this.pos - this.offset) % this.count) + this.count) % this.count; }
      normalize() {
        const target = this.real() + this.offset;
        if (target !== this.pos) this.setPos(target, false);
      }
      go(pos) {
        if (pos < 1 || pos > this.slides.length - 2) { this.normalize(); pos = Math.max(1, Math.min(this.slides.length - 2, pos)); }
        this.setPos(pos, true);
        this.restart();
      }
      next() { if (this.pos >= this.slides.length - 2) this.normalize(); this.go(this.pos + 1); }
      prev() { if (this.pos <= 1) this.normalize(); this.go(this.pos - 1); }
      update() {
        const r = this.real();
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === r ? 'true' : 'false'));
        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.pos));
      }
      start() {
        if (!this.auto || this.paused) return;
        this.stop();
        this.timer = setInterval(() => this.next(), this.delay);
        this.classList.add('is-playing');
      }
      stop() { clearInterval(this.timer); this.timer = null; this.classList.remove('is-playing'); }
      restart() {
        if (!this.timer) return;
        this.stop();
        requestAnimationFrame(() => this.start());
      }
      onClick(e) {
        if (this.dragged) { e.preventDefault(); e.stopPropagation(); this.dragged = false; return; }
        const slide = e.target.closest('.vt-slideshow-peek__slide');
        const i = this.slides.indexOf(slide);
        if (i > -1 && i !== this.pos) { e.preventDefault(); this.go(i); }
      }
      onDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.startX = e.clientX; this.startY = e.clientY; this.dx = 0; this.dragging = true; this.dragged = false;
      }
      onMove(e) {
        if (!this.dragging) return;
        this.dx = e.clientX - this.startX;
        if (!this.dragged && Math.abs(this.dx) > 6 && Math.abs(this.dx) > Math.abs(e.clientY - this.startY)) {
          this.dragged = true; this.classList.add('is-dragging'); this.stop();
        }
        if (this.dragged) this.style.setProperty('--vt-sp-drag', this.dx + 'px');
      }
      onUp() {
        if (!this.dragging) return;
        this.dragging = false;
        this.classList.remove('is-dragging');
        this.style.setProperty('--vt-sp-drag', '0px');
        if (this.dragged) {
          if (this.dx < -40) this.next(); else if (this.dx > 40) this.prev();
          this.start();
          setTimeout(() => { this.dragged = false; }, 50);
        }
      }
    }
    customElements.define('vt-slideshow-peek', VtSlideshowPeek);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-video-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-video-card')) {
    class VtVideoCard extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('[data-play]');
        if (!this.video || !this.button) return;
        this.button.addEventListener('click', () => {
          this.dataset.playing = '';
          this.video.controls = true;
          const p = this.video.play();
          if (p && p.catch) p.catch(() => {});
          this.video.focus();
        });
      }
    }
    customElements.define('vt-video-card', VtVideoCard);
  }

  if (!customElements.get('vt-snap-carousel')) {
    class VtSnapCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.dots = this.querySelector('[data-dots]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index() - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.index() + 1));
        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.track);
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
      items() { return Array.from(this.track.children); }
      step() {
        const it = this.items();
        if (it.length > 1) return it[1].offsetLeft - it[0].offsetLeft;
        return this.track.clientWidth || 1;
      }
      count() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 2) return 1;
        return Math.min(this.items().length, Math.ceil(max / this.step() - 0.05) + 1);
      }
      index() { return Math.min(this.count() - 1, Math.round(this.track.scrollLeft / this.step())); }
      go(i) {
        const n = this.count();
        const target = Math.max(0, Math.min(n - 1, i));
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({ left: target === n - 1 ? max : target * this.step(), behavior: 'smooth' });
      }
      build() {
        const n = this.count();
        if (this.dots) {
          if (this.dots.childElementCount !== n) {
            this.dots.innerHTML = '';
            for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.setAttribute('aria-label', (i + 1) + ' / ' + n);
              b.addEventListener('click', () => this.go(i));
              this.dots.appendChild(b);
            }
          }
          this.dots.hidden = n < 2;
        }
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const n = this.count();
        const i = this.track.scrollLeft >= max - 2 ? n - 1 : this.index();
        if (this.dots) Array.from(this.dots.children).forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }
    customElements.define('vt-snap-carousel', VtSnapCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-video-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-video-story')) {
    class VtVideoStory extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('[data-play]');
        if (btn) btn.addEventListener('click', () => this.play());
      }
      play() {
        const tpl = this.querySelector('template[data-embed]');
        if (tpl) {
          this.appendChild(tpl.content.cloneNode(true));
          tpl.remove();
        }
        this.classList.add('is-playing');
        const video = this.querySelector('video');
        if (video) { video.play().catch(() => {}); video.focus(); }
      }
    }
    customElements.define('vt-video-story', VtVideoStory);
  }

  } catch(e) { console.error(e); }
})();
})();
